import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPin4 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M20 10c0-2.5-1-8-8-8s-8 5.5-8 8c0 6.4 5.333 10.5 8 12 2.667-1.5 8-5.6 8-12'
      opacity={0.6}
    />
    <path fill='#fff' d='M14.5 9q0 2.5-2.5 2.5T9.5 9 12 6.5 14.5 9' />
  </svg>
)
const ForwardRef = forwardRef(SvgPin4)
export default ForwardRef
